"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var hasStoreAdditionalFunctionalities = function hasStoreAdditionalFunctionalities(language) {
  var _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  return Boolean(parseInt((_global$__appConfig__ = (_global$__appConfig__2 = global.__appConfig__) === null || _global$__appConfig__2 === void 0 ? void 0 : (_global$__appConfig__3 = _global$__appConfig__2.storeAdditionalFunctionalities) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3[language === null || language === void 0 ? void 0 : language.language]) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : 0));
};
var _default = hasStoreAdditionalFunctionalities;
exports["default"] = _default;